export enum CareerBranch {
  Main = 'main',
  Secondary = 'secondary',
}
